export default __webpack_public_path__ + "guide--raster-naip-in-studio-480-1c15e6077c2e11d6947e1d96ba509dcd.png";